export default __webpack_public_path__ + "05d7f2114a41e6e63c80aca8cb93511c.png";